import { render } from "./RawMaterialsTable.vue?vue&type=template&id=1892f72b&ts=true"
import script from "./RawMaterialsTable.vue?vue&type=script&lang=ts"
export * from "./RawMaterialsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__